@if (isDownloading) {
	<div class="spinner-border text-primary" role="status">
		<span class="sr-only">Loading...</span>
	</div>
} @else {
	<button (click)="telecharger()" class="ml-4 btn btn-icon btn-soft-secondary"><i class="ri-download-2-line"></i></button>
}
